var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejectionReasonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.044,
    height: 17.044,
    viewBox: "0 0 17.044 17.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22046",
    "data-name": "Group 22046",
    transform: "translate(-358.214 -626.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11217",
    "data-name": "Path 11217",
    d: "M239.255,243.845a4.589,4.589,0,1,1,4.589-4.589,4.594,4.594,0,0,1-4.589,4.589m0-8.472a3.883,3.883,0,1,0,3.883,3.883,3.888,3.888,0,0,0-3.883-3.883",
    transform: "translate(131.363 399.588)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11218",
    "data-name": "Path 11218",
    d: "M272.668,279.021a.353.353,0,0,1-.25-.6l5.981-5.98a.353.353,0,1,1,.5.5l-5.981,5.98a.352.352,0,0,1-.249.1",
    transform: "translate(94.961 363.166)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11219",
    "data-name": "Path 11219",
    d: "M68.589,299.373H64.353a.353.353,0,1,1,0-.706h4.236a.353.353,0,1,1,0,.706",
    transform: "translate(296.383 337.707)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11220",
    "data-name": "Path 11220",
    d: "M67.883,363.373h-3.53a.353.353,0,1,1,0-.706h3.53a.353.353,0,1,1,0,.706",
    transform: "translate(296.383 275.825)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11221",
    "data-name": "Path 11221",
    d: "M140.078,66.824a1.412,1.412,0,1,1,1.412-1.412,1.413,1.413,0,0,1-1.412,1.412m0-2.118a.706.706,0,1,0,.706.706.707.707,0,0,0-.706-.706",
    transform: "translate(224.188 564.607)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11222",
    "data-name": "Path 11222",
    d: "M101.3,173.491a.353.353,0,0,1-.353-.353v-.706a1.06,1.06,0,0,0-1.059-1.059H97.765a1.06,1.06,0,0,0-1.059,1.059v.706a.353.353,0,0,1-.706,0v-.706a1.767,1.767,0,0,1,1.765-1.765h2.118a1.767,1.767,0,0,1,1.765,1.765v.706a.353.353,0,0,1-.353.353",
    transform: "translate(265.441 461.471)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11223",
    "data-name": "Path 11223",
    d: "M6.707,14.826H1.765A1.767,1.767,0,0,1,0,13.061V1.765A1.767,1.767,0,0,1,1.765,0h8.472A1.767,1.767,0,0,1,12,1.765V6.043a.353.353,0,1,1-.706,0V1.765A1.06,1.06,0,0,0,10.237.706H1.765A1.06,1.06,0,0,0,.706,1.765v11.3A1.06,1.06,0,0,0,1.765,14.12H6.707a.353.353,0,1,1,0,.706",
    transform: "translate(358.264 626.489)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectionReasonIcon);
export default __webpack_public_path__ + "static/media/rejection-reason-icon.1e77cb9a2b485d28b2e057611ff520da.svg";
export { ForwardRef as ReactComponent };